/* ==========================================================================
   crocs-product @ 1.4.0 — galeria y equivalencias de talla

   La logica de variantes la sigue manejando Broadcast (<product-info> y
   <variant-selects>): la horma es una opcion real y sus radios viven dentro del
   interruptor del diseno. Aca va lo que el theme no cubre:

   - el carrusel de la imagen grande con miniaturas, flechas y puntos;
   - el interruptor de unidades, que no es una opcion de variante: reescribe la
     etiqueta de cada talla con el valor de custom.us / custom.cm de la variante
     que corresponde a la horma seleccionada.

   1.2.0: si la seccion imprime la tabla de equivalencias de la app crocs-tallas
   (<script data-l51-size-system>, ver snippets/l51-size-system.liquid) las
   etiquetas salen de ahi via window.L51SizeMap, con la horma como segmento.
   Sin tabla, todo sigue como en 1.1.0.

   1.3.0: la linea "Seleccionado" tambien se arma con la tabla y muestra la
   fila completa — horma, CL, US, cm y el codigo crocs — en vez del codigo
   maestro etiquetado como CL. Sin tabla queda la que imprime la seccion.

   1.4.0: el interruptor de segmento sale con cualquier tabla. Las que no
   tienen segmentos (MUJER, HOMBRE, RECIEN NACIDOS) muestran una sola opcion
   con el nombre de la tabla, y NIÑOS solo los rangos que el producto cubre.
   Con una sola opcion no hay nada que elegir: es una etiqueta.

   1.5.0: "+N colores" deja de ser un shell y despliega en la misma grilla los
   hermanos que pasan de color_limit.
   ========================================================================== */

   (function () {
    'use strict';
  
    /* La unidad elegida es estado del cliente. product-info reemplaza el HTML de
       <variant-selects> al cambiar de variante, asi que se guarda aparte y se
       vuelve a aplicar despues de cada reemplazo. */
    var currentUnit = null;
  
    /* Segmento de la grilla (Mujer/Hombre en UNISEX, Pequeños/Grandes en NIÑOS)
       cuando el producto NO trae esa opcion de variante: tambien es estado del
       cliente y se reaplica tras cada reemplazo de <variant-selects>. */
    var currentSegment = null;
  
    /* ---------- Galeria ---------- */
  
    function setupGallery(root) {
      var slides = root.querySelectorAll('[data-crocs-slide]');
      if (slides.length < 2) return;
  
      var thumbs = root.querySelectorAll('[data-crocs-thumb]');
      var dots = root.querySelectorAll('[data-crocs-dot]');
      var prev = root.querySelector('[data-crocs-prev]');
      var next = root.querySelector('[data-crocs-next]');
      var index = 0;
  
      // Detectar contenedores principales basándose en las clases de Crocs / Broadcast
      var mainArea = root.querySelector('.crocs-quickadd__main, .crocs-product__main, .crocs-gallery__main') || root;
      var thumbsScroller = root.querySelector('.crocs-quickadd__thumbs, .crocs-product__thumbs, .crocs-gallery__thumbs__scroller');
  
      /* ----------------------------------------------------------------------
         1. ALTURA DINÁMICA DE LOS THUMBNAILS (ResizeObserver)
         ---------------------------------------------------------------------- */
      function syncThumbsHeight() {
        if (mainArea && thumbsScroller && mainArea !== root) {
          // Aseguramos que el scroller nunca sea más alto que la imagen principal
          thumbsScroller.style.maxHeight = mainArea.offsetHeight + 'px';
          // Nos aseguramos de que el scroll vertical esté habilitado en caso de que el CSS falle
          if (window.innerWidth >= 990) {
            thumbsScroller.style.overflowY = 'auto';
          }
        }
      }
  
      if (mainArea && thumbsScroller && mainArea !== root) {
        if (typeof ResizeObserver !== 'undefined') {
          var resizeObserver = new ResizeObserver(function() {
            syncThumbsHeight();
          });
          resizeObserver.observe(mainArea);
        } else {
          window.addEventListener('resize', syncThumbsHeight);
        }
        requestAnimationFrame(syncThumbsHeight);
      }
      /* ---------------------------------------------------------------------- */
  
      function mark(list, i) {
        var n;
        for (n = 0; n < list.length; n++) {
          list[n].setAttribute('aria-current', n === i ? 'true' : 'false');
        }
      }
  
      function show(i) {
        index = (i + slides.length) % slides.length;
        var n;
        for (n = 0; n < slides.length; n++) {
          slides[n].classList.toggle('is-active', n === index);
        }
        mark(thumbs, index);
        mark(dots, index);
  
        /* ----------------------------------------------------------------------
           2. AUTO-SCROLL DEL THUMBNAIL ACTIVO
           ---------------------------------------------------------------------- */
        if (thumbs.length > 0 && thumbs[index] && thumbsScroller) {
          var thumb = thumbs[index];
          var scrollerRect = thumbsScroller.getBoundingClientRect();
          var thumbRect = thumb.getBoundingClientRect();
  
          // Calcular si está fuera de vista verticalmente (Desktop)
          if (thumbRect.top < scrollerRect.top) {
            thumbsScroller.scrollBy({ top: thumbRect.top - scrollerRect.top - 10, behavior: 'smooth' });
          } else if (thumbRect.bottom > scrollerRect.bottom) {
            thumbsScroller.scrollBy({ top: thumbRect.bottom - scrollerRect.bottom + 10, behavior: 'smooth' });
          }
  
          // Calcular si está fuera de vista horizontalmente (Mobile)
          if (thumbRect.left < scrollerRect.left) {
            thumbsScroller.scrollBy({ left: thumbRect.left - scrollerRect.left - 10, behavior: 'smooth' });
          } else if (thumbRect.right > scrollerRect.right) {
            thumbsScroller.scrollBy({ left: thumbRect.right - scrollerRect.right + 10, behavior: 'smooth' });
          }
        }
        /* ---------------------------------------------------------------------- */
      }
  
      function bind(list) {
        var n;
        for (n = 0; n < list.length; n++) {
          (function (i) {
            list[i].addEventListener('click', function () { show(i); });
          })(n);
        }
      }
  
      bind(thumbs);
      bind(dots);
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
  
      /* ----------------------------------------------------------------------
         3. LOGICA DE SWIPE (Touch) y DRAG (Mouse)
         ---------------------------------------------------------------------- */
      var startX = 0;
      var currentX = 0;
      var isDragging = false;
      var threshold = 50; 
      
      function handleDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        var diffX = startX - currentX;
        
        if (Math.abs(diffX) > threshold && startX !== currentX) {
          if (diffX > 0) {
            show(index + 1); 
          } else {
            show(index - 1); 
          }
        }
      }
  
      mainArea.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        currentX = startX;
        isDragging = true;
      }, { passive: true });
  
      mainArea.addEventListener('touchmove', function(e) {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
      }, { passive: true });
  
      mainArea.addEventListener('touchend', handleDragEnd);
  
      mainArea.addEventListener('mousedown', function(e) {
        startX = e.pageX;
        currentX = startX;
        isDragging = true;
        if (e.target.tagName.toLowerCase() === 'img') {
          e.preventDefault();
        }
      });
  
      mainArea.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        currentX = e.pageX;
      });
  
      mainArea.addEventListener('mouseup', handleDragEnd);
      mainArea.addEventListener('mouseleave', handleDragEnd);
      /* ---------------------------------------------------------------------- */
  
      root.crocsShow = show;
      root.crocsSlideFor = function (mediaId) {
        return root.querySelector('[data-media-image-id="' + mediaId + '"]');
      };
    }
  
    /* ---------- Equivalencias de talla ---------- */
  
    /* Durante el swap de Broadcast conviven dos <variant-selects> por 500ms: el
       nuevo se inserta antes y el viejo queda con display:none hasta que lo
       borran. Todo se busca dentro del visible para no repintar el muerto. */
    function activeSelects(scope) {
      var all = scope.querySelectorAll('variant-selects');
      var n;
      for (n = 0; n < all.length; n++) {
        if (all[n].style.display !== 'none') return all[n];
      }
      return all.length ? all[0] : scope;
    }
  
    function readMap(scope) {
      var node = scope.querySelector('[data-crocs-size-map]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        console.warn('crocs-product: mapa de tallas ilegible', e);
        return null;
      }
    }
  
    /* Grilla de la app crocs-tallas, si la seccion la imprimio y el modulo
       l51-size-map esta cargado. Null = comportamiento 1.1.0. */
    var sizeMapRetries = 0;
  
    function readGrid(scope) {
      if (!scope.querySelector('[data-l51-size-system]')) return null;
  
      var sizeMap = window.L51SizeMap;
      if (!sizeMap || typeof sizeMap.readGrid !== 'function') {
        /* l51-size-map.js va con defer al final de theme.liquid y este archivo
           con defer dentro de la seccion, asi que el primer repintado puede
           correr antes de que exista window.L51SizeMap. Se vuelve a intentar
           cuando terminen de ejecutarse los scripts diferidos. */
        if (sizeMapRetries < 3) {
          sizeMapRetries++;
          var retry = function () { init(); };
          if (document.readyState === 'complete') {
            setTimeout(retry, 100 * sizeMapRetries);
          } else {
            document.addEventListener('DOMContentLoaded', retry, { once: true });
            window.addEventListener('load', retry, { once: true });
          }
        }
        return null;
      }
  
      try {
        return sizeMap.readGrid(scope);
      } catch (e) {
        return null;
      }
    }
  
    /* Nombre de la tabla resuelta, para etiquetar el toggle cuando la tabla no
       trae segmentos. Viaja como atributo del <script>, no dentro del grid. */
    function readSystemName(scope) {
      var node = scope.querySelector('[data-l51-size-system]');
      if (!node) node = document.querySelector('[data-l51-size-system]');
      return node ? node.getAttribute('data-l51-system-name') || '' : '';
    }
  
    /* La horma seleccionada ("Mujer", "Hombre") se casa con las opciones de
       segmento de la grilla por etiqueta o por key. Sin horma, la primera. */
    function gridSegment(grid, gender) {
      var sizeMap = window.L51SizeMap;
      if (!grid || !grid.segments || !grid.segments.options) return undefined;
      var wanted = sizeMap.norm(gender);
      var options = grid.segments.options;
      var n;
      if (wanted) {
        for (n = 0; n < options.length; n++) {
          if (sizeMap.norm(options[n].label) === wanted || sizeMap.norm(options[n].key) === wanted) {
            return options[n].key;
          }
        }
      }
      return sizeMap.initialSegment([], grid);
    }
  
    /* Con que segmento pintar. En orden: la horma real del producto (opcion de
       variante), el toggle de segmento de la grilla (estado del cliente), el
       segmento de la talla ya seleccionada (subset) y, si no, initialSegment:
       en scale la primera opcion, en subset el rango con mas variantes
       disponibles. Pura, para poder testearla. */
    function pickSegment(grid, gender, current, selectedSize, variants) {
      var sizeMap = window.L51SizeMap;
      if (!grid || !grid.segments || !grid.segments.options || !grid.segments.options.length) return undefined;
  
      var options = grid.segments.options;
      var wanted = sizeMap.norm(gender);
      var n;
  
      if (wanted) {
        for (n = 0; n < options.length; n++) {
          if (sizeMap.norm(options[n].label) === wanted || sizeMap.norm(options[n].key) === wanted) {
            return options[n].key;
          }
        }
      }
  
      for (n = 0; n < options.length; n++) {
        if (current && options[n].key === current) return current;
      }
  
      if (grid.segments.mode === 'subset' && selectedSize) {
        var key = sizeMap.norm(selectedSize);
        var rows = grid.rows || [];
        for (n = 0; n < rows.length; n++) {
          if (rows[n] && sizeMap.norm(rows[n].master) === key && rows[n].segment) return rows[n].segment;
        }
      }
  
      return sizeMap.initialSegment(variants || [], grid);
    }
  
    /* Texto de una talla para la unidad activa. Pura, para poder testearla:
       - con grilla: la equivalencia de la app (o el codigo crudo si no hay);
       - sin grilla: la primera unidad muestra el valor base y las otras leen el
         mapa custom.us / custom.cm de la variante (comportamiento 1.1.0). */
    function labelFor(base, target, first, map, gender, grid, segment) {
      if (grid && window.L51SizeMap) {
        var seg = segment !== undefined ? segment : gridSegment(grid, gender);
        return String(window.L51SizeMap.display(base, grid, target, seg));
      }
      if (target !== first && map) {
        var entry = map[gender + '||' + base];
        var value = entry ? entry[target] : '';
        /* Sin equivalencia se mantiene el valor base en vez de dejar el hueco */
        return value ? value : base;
      }
      return base;
    }
  
    function selectedGender(scope) {
      /* La horma es la unica opcion dentro del interruptor de radios */
      var checked = activeSelects(scope).querySelector('.crocs-toggle--radios input:checked');
      return checked ? checked.value : '';
    }
  
    /* Variantes de talla del producto tal como estan en los radios. */
    function sizeVariants(active) {
      var inputs = active.querySelectorAll('[data-crocs-sizes] input[type="radio"]');
      var list = [];
      var n;
      for (n = 0; n < inputs.length; n++) {
        list.push({ master: inputs[n].value, available: !inputs[n].disabled });
      }
      return list;
    }
  
    function selectedSize(active) {
      var checked = active.querySelector('[data-crocs-sizes] input[type="radio"]:checked');
      return checked ? checked.value : '';
    }
  
    /* ---------- Linea "Seleccionado" ---------- */
  
    /* Fila de la grilla para un codigo maestro, comparada con norm(). */
    function gridRow(grid, master) {
      var sizeMap = window.L51SizeMap;
      var rows = (grid && grid.rows) || [];
      var key = sizeMap ? sizeMap.norm(master) : String(master || '');
      var n;
  
      if (!key) return null;
  
      for (n = 0; n < rows.length; n++) {
        if (!rows[n]) continue;
        var candidate = sizeMap ? sizeMap.norm(rows[n].master) : String(rows[n].master);
        if (candidate === key) return rows[n];
      }
      return null;
    }
  
    /* Etiqueta de la horma cuando no es una opcion de variante: el segmento
       activo de la grilla. Solo en "scale" (Mujer/Hombre); en "subset" el
       segmento es un rango de tallas ("Pequenos") y no describe la seleccion. */
    function segmentLabel(grid, segment) {
      if (!grid || !grid.segments || grid.segments.mode !== 'scale') return '';
      var options = grid.segments.options || [];
      var n;
      for (n = 0; n < options.length; n++) {
        if (options[n] && options[n].key === segment) return options[n].label || options[n].key;
      }
      return '';
    }
  
    /* Piezas de la linea "Seleccionado", en el orden del diseno: la horma y
       despues una por columna de la grilla, incluida la oculta con el codigo
       crocs ("Mujer, 33 CL, 4 US, 20 cm, M2 W4 crocs"). La unidad sale del
       suffix de la columna (" cm") o, si no tiene, de su etiqueta (CL, US,
       Crocs): ninguna va hardcodeada. Pura, para poder testearla.
       @returns {Array<{value:string, unit:string, key:string}>} */
    function selectedItems(master, grid, segment, gender) {
      var items = [];
      var horma = gender || segmentLabel(grid, segment);
  
      if (horma) items.push({ value: String(horma), unit: '', key: 'gender' });
  
      var row = gridRow(grid, master);
  
      if (!row) {
        /* Sin fila no hay equivalencias: el codigo maestro crudo, la regla de
           oro de l51-size-map. */
        if (master) items.push({ value: String(master), unit: '', key: 'master' });
        return items;
      }
  
      (grid.columns || []).forEach(function (column) {
        if (!column || !column.key) return;
  
        var cell = row[column.key];
        var value = cell && typeof cell === 'object' ? cell[segment] : cell;
        if (value == null || String(value).trim() === '') return;
  
        items.push({
          value: String(value).trim(),
          unit: column.suffix
            ? String(column.suffix).trim()
            : String(column.label || '').trim(),
          key: column.key
        });
      });
  
      return items;
    }
  
    /* La linea vive dentro de <variant-selects>, asi que el servidor la reimprime
       con cada cambio de variante y esto la reescribe despues, igual que las
       etiquetas de la grilla. Sin grilla se deja tal como vino (1.2.0). */
    function renderSelected(active, grid, segment, gender) {
      var line = active.querySelector('[data-crocs-selected]');
      if (!line || !grid) return;
  
      var master = selectedSize(active);
      if (!master) return;
  
      var items = selectedItems(master, grid, segment, gender);
      if (!items.length) return;
  
      var label = line.querySelector('.crocs-buybox__selected__label');
  
      while (line.firstChild) line.removeChild(line.firstChild);
      if (label) line.appendChild(label);
  
      items.forEach(function (item, index) {
        if (index > 0) {
          var sep = document.createElement('span');
          sep.className = 'crocs-buybox__selected__sep';
          sep.textContent = '\u2022';
          line.appendChild(sep);
        }
  
        var el = document.createElement('span');
        el.className = 'crocs-buybox__selected__item';
        el.setAttribute('data-l51-column', item.key);
        /* El espacio va en el texto, no en el CSS: el item es inline y asi se
           parte igual que lo que imprime la seccion. */
        el.appendChild(document.createTextNode(item.unit ? item.value + ' ' : item.value));
  
        if (item.unit) {
          var unit = document.createElement('span');
          unit.textContent = item.unit;
          el.appendChild(unit);
        }
  
        line.appendChild(el);
      });
    }
  
    /* "RECIEN NACIDOS" -> "Recien Nacidos". El nombre de la tabla lo escribe el
       comercio para el admin (en mayusculas) y el diseno lo muestra en capital
       de titulo. Pura, para poder testearla. */
    function titleCase(text) {
      return String(text == null ? '' : text)
        .trim()
        .toLowerCase()
        .replace(/(^|[\s(\/-])([^\s(\/-])/g, function (match, before, letter) {
          return before + letter.toUpperCase();
        });
    }
  
    /* Opciones del toggle de segmento:
       - con segmentos, las de la tabla, y en "subset" (NIÑOS) solo los rangos que
         el producto realmente cubre, para que uno que solo trae J1-J6 muestre
         "Niños Grandes" y no una pestaña vacia;
       - sin segmentos (MUJER, HOMBRE, RECIEN NACIDOS) una sola opcion con el
         nombre de la tabla: el diseno igual muestra el interruptor, porque dice
         en que escala esta la talla.
       Pura, para poder testearla. */
    function segmentOptions(grid, variants, name) {
      if (!grid) return [];
  
      var segments = grid.segments;
  
      if (!segments || !segments.options || !segments.options.length) {
        var label = titleCase(name);
        return label ? [{ key: null, label: label }] : [];
      }
  
      var options = segments.options.slice();
  
      if (segments.mode === 'subset') {
        var counts = window.L51SizeMap.segmentCounts(variants, grid);
        var covered = options.filter(function (option) {
          return option && counts[option.key] && counts[option.key].total > 0;
        });
        /* Si no cubre ninguno, ninguna talla esta en la tabla: se dejan todos y
           mas abajo salen deshabilitados, como antes. */
        if (covered.length) options = covered;
      }
  
      return options;
    }
  
    /* Toggle de segmento generado desde la grilla. Solo si el producto no trae
       la horma como opcion de variante (en ese caso los radios ya la resuelven).
       Reusa las clases del toggle de unidades para verse igual que el diseno. */
    function ensureSegmentToggle(scope, active, grid, segment) {
      var existing = active.querySelector('[data-l51-segments]');
      var hasGenderOption = !!active.querySelector('.crocs-toggle--radios');
      var segments = grid && grid.segments;
      var variants = sizeVariants(active);
      var options = segmentOptions(grid, variants, readSystemName(scope));
  
      if (!options.length || hasGenderOption) {
        if (existing) existing.parentNode.removeChild(existing);
        return;
      }
  
      var group = existing;
      if (!group) {
        group = document.createElement('div');
        group.setAttribute('data-l51-segments', '');
        var anchor = active.querySelector('[data-crocs-units]') || active.querySelector('[data-crocs-sizes]');
        if (!anchor) return;
        anchor.parentNode.insertBefore(group, anchor);
      }
  
      /* Una sola opcion: no hay nada que elegir, asi que es una etiqueta con la
         forma de la pastilla activa y a todo el ancho, como en el diseno. */
      var single = options.length === 1;
  
      group.className = 'crocs-toggle crocs-buybox__block' + (single ? ' crocs-toggle--single' : '');
      if (single) {
        group.removeAttribute('role');
        group.removeAttribute('aria-label');
      } else {
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', (segments && segments.label) || 'Segmento');
      }
  
      var counts = window.L51SizeMap.segmentCounts(variants, grid);
      var subset = !!(segments && segments.mode === 'subset');
      group.innerHTML = '';
  
      options.forEach(function (option) {
        var label = option.label || option.key;
  
        if (single) {
          var tag = document.createElement('span');
          tag.className = 'crocs-toggle__option';
          tag.textContent = label;
          group.appendChild(tag);
          return;
        }
  
        var btn = document.createElement('button');
        btn.className = 'crocs-toggle__option';
        btn.type = 'button';
        btn.setAttribute('data-l51-segment', option.key);
        btn.setAttribute('aria-pressed', option.key === segment ? 'true' : 'false');
        btn.textContent = label;
        if (subset && counts[option.key] && counts[option.key].total === 0) btn.disabled = true;
        btn.addEventListener('click', function () {
          currentSegment = option.key;
          applyUnit(scope, null);
        });
        group.appendChild(btn);
      });
    }
  
    /* En subset (NIÑOS) el segmento decide QUE tallas se listan. */
    function filterSizes(active, grid, segment) {
      var wrappers = active.querySelectorAll('[data-crocs-sizes] .crocs-size');
      var subset = !!(grid && grid.segments && grid.segments.mode === 'subset');
      var n;
      for (n = 0; n < wrappers.length; n++) {
        var input = wrappers[n].querySelector('input[type="radio"]');
        var show = true;
        if (subset && input) {
          show = window.L51SizeMap.visibleVariants([{ master: input.value }], grid, segment).length > 0;
        }
        wrappers[n].hidden = !show;
      }
    }
  
    function applyUnit(scope, unit) {
      var active = activeSelects(scope);
      /* El toggle de unidades es opcional (la seccion no lo imprime si no hay
         etiquetas configuradas), pero la grilla y la linea "Seleccionado" se
         repintan igual. */
      var group = active.querySelector('[data-crocs-units]');
      var buttons = group ? group.querySelectorAll('[data-crocs-unit]') : [];
      var first = buttons.length ? buttons[0].getAttribute('data-crocs-unit') : null;
      var target = unit || currentUnit || first;
      var n;
  
      for (n = 0; n < buttons.length; n++) {
        buttons[n].setAttribute(
          'aria-pressed',
          buttons[n].getAttribute('data-crocs-unit') === target ? 'true' : 'false'
        );
      }
  
      currentUnit = target;
  
      var grid = readGrid(scope);
      var map = grid ? null : readMap(scope);
      var gender = selectedGender(scope);
      var segment;
  
      if (grid) {
        segment = pickSegment(grid, gender, currentSegment, selectedSize(active), sizeVariants(active));
        if (segment !== undefined && !gender) currentSegment = segment;
        ensureSegmentToggle(scope, active, grid, segment);
        filterSizes(active, grid, segment);
      }
  
      var labels = active.querySelectorAll('[data-crocs-size]');
  
      for (n = 0; n < labels.length; n++) {
        var base = labels[n].getAttribute('data-crocs-size');
        var text = labelFor(base, target, first, map, gender, grid, segment);
  
        /* Solo se escribe si cambio: asi este repintado no provoca mutaciones
           en cadena si algun dia se observa el subarbol. */
        if (labels[n].textContent !== text) labels[n].textContent = text;
      }
  
      renderSelected(active, grid, segment, gender);
    }
  
    function setupUnits(scope) {
      var group = activeSelects(scope).querySelector('[data-crocs-units]');
      if (!group) return;
  
      var buttons = group.querySelectorAll('[data-crocs-unit]');
      var n;
  
      for (n = 0; n < buttons.length; n++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            applyUnit(scope, btn.getAttribute('data-crocs-unit'));
          });
        })(buttons[n]);
      }
  
      applyUnit(scope, null);
    }
  
    /* ---------- Texto del boton de compra ---------- */
  
    /* product-info reescribe el texto del boton con window.theme.strings en cada
       cambio de variante, y la tienda corre en ingles ("Add to cart"). El texto
       del diseno viaja en el propio boton y se restituye despues. */
    function syncSubmitLabel(scope) {
      var buttons = scope.querySelectorAll('[data-crocs-atc-text]');
      var n;
  
      for (n = 0; n < buttons.length; n++) {
        var button = buttons[n];
        var label = button.querySelector('[data-add-to-cart-text]');
        if (!label) continue;
  
        var text = button.disabled
          ? button.getAttribute('data-crocs-soldout-text')
          : button.getAttribute('data-crocs-atc-text');
  
        if (text && label.textContent.trim() !== text) label.textContent = text;
      }
    }
  
    /* ---------- Arranque ---------- */
  
    function init() {
      /* El modal de agregado rapido reusa los mismos interruptores y el mismo
         mapa de equivalencias que la ficha. */
      var roots = document.querySelectorAll('.crocs-product, .crocs-quickadd');
      var n;
  
      for (n = 0; n < roots.length; n++) {
        var scope = roots[n];
        var gallery = scope.querySelector('[data-crocs-gallery]');
  
        if (gallery && !gallery.dataset.crocsReady) {
          gallery.dataset.crocsReady = 'true';
          setupGallery(gallery);
        }
  
        /* La horma es una opcion de variante: el theme refetchea la seccion y al
           terminar avisa por variantChange. Igual se escucha el change directo
           para que las equivalencias se repinten al instante, sin depender de que
           ese refetch llegue. */
        if (!scope.dataset.crocsGenderBound) {
          scope.dataset.crocsGenderBound = 'true';
          scope.addEventListener('change', function (event) {
            if (!event.target.closest) return;
            if (!event.target.closest('.crocs-toggle--radios')) return;
            applyUnit(scope, null);
          });
        }
  
        /* "+N colores": despliega los hermanos que pasan de color_limit. Todo se
           resuelve desde event.target y no desde scope, que en este for es una
           var y quedaria capturada con el ultimo valor. */
        if (!scope.dataset.crocsMoreBound) {
          scope.dataset.crocsMoreBound = 'true';
          scope.addEventListener('click', function (event) {
            if (!event.target.closest) return;
  
            var more = event.target.closest('[data-crocs-more-colors]');
            if (!more) return;
  
            var list = more.closest('.crocs-swatches');
            if (!list) return;
  
            var open = list.classList.toggle('is-expanded');
            more.setAttribute('aria-expanded', open ? 'true' : 'false');
  
            var label = open
              ? more.getAttribute('data-crocs-less-text')
              : more.getAttribute('data-crocs-more-text');
            if (label) more.textContent = label;
          });
        }
  
        syncSubmitLabel(scope);
  
        var units = activeSelects(scope).querySelector('[data-crocs-units]');
        if (units && !units.dataset.crocsReady) {
          units.dataset.crocsReady = 'true';
          setupUnits(scope);
        } else {
          /* Tras un reemplazo de variant-selects hay que repintar las etiquetas */
          applyUnit(scope, null);
        }
      }
    }
  
    function onVariantChange(payload) {
      init();
  
      var media = payload && payload.data && payload.data.variant && payload.data.variant.featured_media;
      if (!media) return;
  
      var galleries = document.querySelectorAll('[data-crocs-gallery]');
      var n;
      for (n = 0; n < galleries.length; n++) {
        var g = galleries[n];
        if (!g.crocsSlideFor) continue;
        var slide = g.crocsSlideFor(media.id);
        if (slide) g.crocsShow(Number(slide.getAttribute('data-crocs-slide')));
      }
    }
  
    function boot() {
      init();
      if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
        window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, onVariantChange);
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  
    document.addEventListener('shopify:section:load', init);
  
    /* Expuesto solo para theme-tests/crocs-product.test.js */
    window.CrocsProduct = {
      labelFor: labelFor,
      gridSegment: gridSegment,
      pickSegment: pickSegment,
      selectedItems: selectedItems,
      segmentOptions: segmentOptions,
      titleCase: titleCase
    };
  
    /* El modal de agregado rapido inserta su contenido por AJAX: el theme avisa
       con theme:quick-add:open y ahi hay que enganchar los interruptores. */
    document.addEventListener('theme:quick-add:open', function () {
      init();
    });
  })();
  